import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { getClientsList, getFirmsList, getModalityList } from '../../service/MasterService';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import userContext from '../../context/users/UserContext';
import { USERTYPES } from '../../constants/Constants';
import { constantStyleForSelect } from '../../components/CustomSelect';
import loaderContext from '../../context/loader/LoaderContext';
import { useTranslation } from 'react-i18next';
import toastContext from '../../context/toast/ToastContext';
import themeContext from '../../context/theme/ThemeContext';
import Select from "react-select";
import OutsideClickHandler from 'react-outside-click-handler';
import { Checkbox, Dropdown, DropdownMenuItemType,
  SelectableOptionMenuItemType,
  SearchBox,
  ComboBox,
  TextField,
  CheckboxVisibility} from '@fluentui/react';
import { getModalityListForRestriction } from '../../service/StudyReportService';
import "./AddRestrictionForClientTemplate.css";
import SearchableDropDown from './helper/SearchDropdown';

const AddRestrictionForClient = (props) => {
  const dropdownRef = useRef(null);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const [modalityList, setModalityList] = useState([]);
  const [firmList, setFirmList] = useState([]);

  const [selectedModality, setSelectedModality] = useState("");
  // const [selectedModalityList, setSelectedModalityList] = useState(props.values.modalityId);
  const [selectedFirmId, setSelectedFirmId] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");

  const { showToastv2 } = useContext(toastContext);

  const { roles, username, loadByUsername, authenticated, userId, checkForUserAccess } =
    useContext(userContext);
  const { firmId } = useContext(userContext);
  const { t } = useTranslation();

  const [clientList, setClientList] = useState([]);

  const [selectedModalityKeys, setSelectedModalityKeys] = useState([]);

  const [firmFilteredItems, setFirmFilteredItems] = useState(firmList);
  const [clientFilteredItems, setClientFilteredItems] = useState(clientList);
  const [modalityFilteredItems, setModalityFilteredItems] = useState(modalityList);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const dropDownStyle = {
    dropdown: {
      width: "100%"
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "300px",
      overflowY: 'auto',
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white"
    },
  };

  const modalityDropDownStyle = {
    dropdown: {
      width: "100%"
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "250px",
      overflowY: 'auto',
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white"
    },
  };

  const fetchModalityList = async () => {
    const response = await getModalityList();
    let modalityList = [];
    response.data.data.modalityList.map((modality) => {
      modalityList.push({
        key: modality.id,
        text: modality.name,
      });
    });

    setModalityList(modalityList);
    setModalityFilteredItems(modalityList);
  };

  const fetchFirmList = async () => {
    const response = await getFirmsList();
    let firmList = [];
    response?.data?.data?.map((firm) => {
      firmList.push({
        key: firm.id,
        text: firm.name,
      });
    });
    setFirmList(firmList);
    setFirmFilteredItems(firmList)
  };

  const fetchClientList = async (firmId) => {
    const response = await getFirmsList();
    let clientList = [];
    response.data.data.map((client) => {
      clientList.push({
        key: client.id,
        text: client.name,
      });
    });

    setClientList(clientList);
    setClientFilteredItems(clientList);
  };

  const fetchClientListForAdmin = async (firmId) => {
    console.log(firmId);
    const response = await getClientsList(firmId);
    let clientList = [];
    response.data.data.map((client) => {
      clientList.push({
        key: client.id,
        text: client.name,
      });
    });

    setClientList(clientList);
    setClientFilteredItems(clientList);
  };

  useEffect(() => {
    if (props.userRole === USERTYPES.FIRMADMIN || props.userRole === USERTYPES.SUPERVISOR) {
      fetchClientList(firmId);
    }
  }, [props.userRole]);

  const fetchModalityListForAdmin = async (firmId, clientId) => {
    console.log(firmId, clientId);
    firmId = firmId != null && firmId != "" ? firmId : props.values.firmId;
    setSelectedModalityKeys([]);
    props.setSelectedModalityList([]);
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await getModalityListForRestriction(firmId, clientId);
    if(response.data.result == "SUCCESS"){
      console.log("response.data.data----",response.data.data);

      let modalityList = response.data.data.map((modality) => modality );
      setSelectedModalityKeys(modalityList);
      props.setSelectedModalityList(modalityList);
    }
    setLoaderRunning(false);
    ref.current.complete();
  };

  const fetchData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    await fetchModalityList();
    await fetchFirmList();
    setLoaderRunning(false);
    ref.current.complete();
  };

  useEffect(() =>{
    fetchData();
  },[]);

  const handleSelectAllClick = (isChecked) =>{
    let list = isChecked ? modalityList.map(opt => opt.key ) : [];
    setSelectAllChecked(isChecked);
    setSelectedModalityKeys(list);
    props.setSelectedModalityList(list);
    setModalityFilteredItems(modalityList);
  }

  const handleSelectedModalityList = (event, item) => {
    if (item) {
      const newSelectedKeys = item.selected
        ? [...props.selectedModalityList, item.key]
        : props.selectedModalityList.filter(key => key !== item.key);
        props.setSelectedModalityList(newSelectedKeys);
    }
    setSelectAllChecked(false);
    setModalityFilteredItems(modalityList);
  };

  // useEffect(()=>{
  //   props.setValues({
  //    ...props.values,
  //     modalityId: props.selectedModalityList,
  //     clientId: selectedClientId,
  //     firmId: selectedFirmId
  //   });
  // },[props.selectedModalityList, selectedClientId, selectedFirmId]);

  const onDropDownSearch = (
    searchValue,
    initialValues
  ) => {
    if (searchValue == null || searchValue == "") {
      return [...initialValues];
    }
    const filteredOptions = [...initialValues].filter(
      (i) => {
        let text = i.text.toLowerCase();
        return text.includes(searchValue.toLowerCase());
      }
    );


    return filteredOptions;
  }

  

  const clientNoOptionList = () => {
    return [{key:"no options",text:"no options available", disabled:true}];
  }

  const handleClickOutside = () => {
    setFirmFilteredItems(firmList);
    setModalityFilteredItems(modalityList);
    setClientFilteredItems(clientList);
  };

  return (
    <>
      <div
        className="tab-section modal-scroll"
        style={{
          padding: "0px",
          height: "100%",
          width: "100%",
          // overflowY: "scroll",
        }}
      >
        <div style={{ width: "95%", padding: "10px 0px 10px 10px" }}>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row" style={{display:"flex",flexDirection:"row"}}>
              
              {(props.userRole === USERTYPES.ADMIN &&
                props.tabId == 3) && (
                  <div className="restriction-modal-scroll form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl8" style={{width:"50%"}}>
                  <OutsideClickHandler onOutsideClick={handleClickOutside}>
                        <SearchableDropDown 
                        dropDownStyle={dropDownStyle}
                        defaultSelectedKey={selectedFirmId}
                        onChange={(event, item) => {
                          console.log(item, item.key, item.text);
                          setSelectedFirmId(item.key)
                          props.setValues({
                            ...props.values,
                            firmId: "" + item.key,
                            clientId: ""
                          });
                          setFirmFilteredItems(firmList);
                          setSelectedClientId(null);
                          props.setSelectedModalityList([]);
                          setSelectAllChecked(false);
                          fetchClientListForAdmin(item.key);
                        }}
                        onSearchValueChanged={(searchValue) => {
                          console.log("search value ", searchValue);
                                const newOptions = onDropDownSearch(
                                  searchValue,
                                  firmList,
                                );
                                setFirmFilteredItems(newOptions);
                        }}
                        options={firmFilteredItems.length > 0 ? firmFilteredItems : [{key:"no options",text:"no options available", disabled:true}]}
                        name="Firm list"
                        placeholder={t("string-literals.report-template-firmId")}
                        isMultiSelect={false}
                        isRequired={true}
                        className="restriction-modal-scroll form-field ms-Grid-col custom-restriction-dropdown"
                        label={t("report-templates.firm")}
                        style={{width: "100%"}}
                        errorMessage={props.values.firmId == "" ? props.errors.firmId : ""}
                      />
                  </OutsideClickHandler>
                  </div>
                )}
              {((props.userRole === USERTYPES.ADMIN && props.tabId == 3) ||
                props.userRole === USERTYPES.FIRMADMIN || props.userRole === USERTYPES.SUPERVISOR) &&
                (
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl8" style={{width:"50%",display:"flex",flexDirection:"column"}}>
                    <OutsideClickHandler onOutsideClick={handleClickOutside}>
                      <SearchableDropDown 
                        dropDownStyle={dropDownStyle}
                        defaultSelectedKey={selectedClientId}
                        onChange={(event, item) => {
                          setSelectedClientId(item.key)
                          props.setValues({
                            ...props.values,
                            clientId: "" + item.key,
                          });
                          setSelectAllChecked(false);
                          fetchModalityListForAdmin(selectedFirmId, item.key);
                          setClientFilteredItems(clientList);
                        }}
                        onSearchValueChanged={(searchValue) => {
                                const newOptions = onDropDownSearch(
                                  searchValue,
                                  clientList,
                                );
                                setClientFilteredItems(newOptions);
                        }}
                        options={clientFilteredItems.length > 0 ? clientFilteredItems : clientNoOptionList() }
                        name="client list"
                        placeholder={t("string-literals.report-template-clientId")}
                        className="form-field ms-Grid-col custom-restriction-dropdown modal-scroll"
                        label={t("report-templates.client")}
                        style={{width: "100%"}}
                        isRequired={true}
                        isMultiSelect={false}
                        errorMessage={props.values.clientId == "" ? props.errors.clientId : ""}
                      />
                  </OutsideClickHandler>
                  </div>
                )}
            </div>
            <div className="ms-Grid-row" >
              <>
                <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl8" style={{width:"70%", display:"flex",flexDirection:"row"}}>
                <OutsideClickHandler onOutsideClick={handleClickOutside}>
                  <SearchableDropDown 
                        dropDownStyle={modalityDropDownStyle}
                        selectedKeys={props.selectedModalityList}
                        onChange={handleSelectedModalityList}
                        onSearchValueChanged={(searchValue) => {
                                const newOptions = onDropDownSearch(
                                  searchValue,
                                  modalityList,
                                );
                                setModalityFilteredItems(newOptions);
                        }}
                        options={modalityFilteredItems.length > 0 ? modalityFilteredItems : []}
                        name="modality list"
                        className="form-field ms-Grid-col custom-restriction-dropdown modal-scroll"
                        style={{width: "100%"}}
                        label={t("navbar.modality")}
                        placeholder={"Select modality"}
                        isMultiSelect={true}
                        isRequired={false}
                        errorMessage={props.restrictedModalityErrorMsg != "" ? props.restrictedModalityErrorMsg: ""}
                      />
                    </OutsideClickHandler>
                  <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10" style={{ display: "block",whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis",margin:"auto", paddingTop:"27px"}}>
                          <Checkbox
                            key="select-all"
                            label="Select All"
                            onChange={(e, isChecked) => handleSelectAllClick(isChecked)}   
                            checked={selectAllChecked}                        
                          />
                      </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddRestrictionForClient